import axios from 'axios';

const moduleUser = {
    namespaced: true,
    state: () => ({
        user: null,
    }),
    getters: {
        user: state => {
            return state.user;
        },
    },
    mutations: {
        /**
         * Set the state user
         * @param {object} state The state of the Vuex Store
         * @param {object} user The new value for user
         */
        setUser (state, {user}) {
            state.user = user;
        },
    },
    actions: {
        /**
         * Calls the User@update api, and fill the state users
         * @param {object} context Exposes the same set of methods/properties on the store instance
         * @return {Promise<object>}
         */
        fetchUser (context) {
            return new Promise((resolve, reject) => {
                context.dispatch('moduleAuth/getValidJWT', null, {root: true}).then((token) => {
                    let url = context.rootState.moduleAuth.heimbasServer + '/api/v1/user';
                    let requestData = {
                        headers: {
                            Authorization: token
                        },
                    };
                    //TO DO use the certificate in the axios request
                    // let certificate = context.rootGetters['moduleAuth/jwtCertificate'];
                    axios.get(url, requestData).then((response) => {
                        context.commit('setUser', {'user': response.data});
                        resolve(response);
                    }).catch((error) => {
                        reject(error);
                    });
                }).catch((error) => {
                    reject(error);
                });
            });
        },

    }
}
export default moduleUser;